// src/faqPage.ts
class FaqPage {
    private openQuestionBlock: HTMLElement | null = null;

    // Selector variables
    private readonly categorySelector = '.faq-category';
    private readonly sectionSelector = '.faq-category-questions';
    //private readonly questionBlockSelector = '.faq-question-block';
    private readonly questionSelector = '.faq-question';
    
    // Page initializer
    private initPageSetup(): void {
        const firstCategory = document.querySelector<HTMLElement>(this.categorySelector);
        if (firstCategory) firstCategory.classList.add('selected');

        // Hide all sections except the first
        const sections = document.querySelectorAll<HTMLElement>(this.sectionSelector);
        sections.forEach((section, index) => {
            if (index > 0) section.style.display = 'none';
        });
    }

    // Category click event
    private initCategoryClick(): void {
        const categories = document.querySelectorAll<HTMLElement>(this.categorySelector);
        const sections = document.querySelectorAll<HTMLElement>(this.sectionSelector);

        categories.forEach(category => {
            category.addEventListener('click', e => {
                e.preventDefault();
                const categoryId = category.dataset.categoryId;
                if (!categoryId) return;

                // Select category tile
                categories.forEach(c => c.classList.remove('selected'));
                category.classList.add('selected');

                // Hide all sections
                sections.forEach(section => {
                    section.style.opacity = '0';
                    section.style.display = 'none';
                });

                // Show selected section
                const targetSection = document.querySelector<HTMLElement>(
                    `${this.sectionSelector}[data-category-id='${categoryId}']`
                );
                if (targetSection) {
                    targetSection.style.display = 'block';
                    setTimeout(() => targetSection.style.opacity = '1', 10);
                }
            });
        });
    }

    // Question click event
    private initQuestionClick(): void {
        const questions = document.querySelectorAll<HTMLElement>(this.questionSelector);

        questions.forEach(question => {
            question.addEventListener('click', e => {
                e.preventDefault();

                // Get the parent block that actually needs the "open" class
                const parentBlock = question.closest('.faq-question-block') as HTMLElement;
                if (!parentBlock) return;

                // Close previously opened block
                if (this.openQuestionBlock && this.openQuestionBlock !== parentBlock) {
                    this.openQuestionBlock.classList.remove("open");
                }

                // Toggle the clicked one
                parentBlock.classList.toggle("open");

                // Save reference
                this.openQuestionBlock = parentBlock.classList.contains("open") ? parentBlock : null;
            });
        });
    }

    // Initialize everything
    public init(): void {
        this.initPageSetup();
        this.initCategoryClick();
        this.initQuestionClick();
    }
}

// Initialize automatically on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    new FaqPage().init();
});
